export function isRecombeeEmail(emailAddress) {
    return emailAddress.includes("@recombee.com")
}